import React, { useEffect, useState } from 'react';
import styles from './CookieBanner.scss';
import { useTranslation } from 'react-i18next';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
    // console.log('Cookies accepted');
  };

  if (!visible) return null;

  return (
    <div className={styles.CookieBanner}>
      <span className={styles.Title}>{t('components.cookieBanner.title')}</span>
      <button className={styles.Button} onClick={acceptCookies}>
        {t('components.cookieBanner.button')}
      </button>
    </div>
  );
};

export default CookieBanner;



// WEBPACK FOOTER //
// ./src/components/CookieBanner/CookieBanner.js